import { render } from "./UpdateReservationModal.vue?vue&type=template&id=e625859e"
import script from "./UpdateReservationModal.vue?vue&type=script&lang=js"
export * from "./UpdateReservationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__